import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardBody} from 'reactstrap';
import { ISeasonGameDto } from '../../WorldDoomLeague';

interface SeasonGameProps {
    game: ISeasonGameDto;
}

const SeasonGame = (props: SeasonGameProps) => {
    return (
        <React.Fragment>
            <Card className='border-white mb-3 gamecard'>
                <CardBody>
                    <NavLink className='text-white text-decoration-none' to={`/matches/${props.game.idGame}`}>
                        {props.game.gamePlayed == false && (
                            <div>
                                <div className='clearfix'>
                                    <span className='float-left h4 text-info'>{props.game.blueTeamName}</span>
                                    <span className='float-right h4 text-danger'>{props.game.redTeamName}</span>
                                </div>
                                <h3 className='text-center text-white'><span className='text-center'>vs.</span></h3>
                            </div>
                        )}
                    {props.game.gamePlayed == true && (
                        <React.Fragment>
                            <div className='clearfix'>
                                <span className='float-left h4 text-info'>{props.game.blueTeamName}</span>
                                <span className='float-right h4 text-danger'>{props.game.redTeamName}</span>
                            </div>
                                <h3 className='text-center text-white'><span className={(props.game.teamWinnerColor == 'b' && 'font-weight-bold')}>{props.game.blueTeamScore}</span> - <span className={(props.game.teamWinnerColor == 'r' && 'font-weight-bold')}>{props.game.redTeamScore}</span></h3>
                        </React.Fragment>
                        )}
                        {props.game.gameDatetime && (
                        <div className='text-right'>{new Intl.DateTimeFormat('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' } as Intl.DateTimeFormatOptions).format(new Date(props.game.gameDatetime))}</div>
                        )}
                        {!props.game.gameDatetime && (
                        <div className='text-right'>TBD</div>
                        )}
                    </NavLink>
                    </CardBody>
                </Card>
        </React.Fragment>
    );
};

export default SeasonGame;